import React, { useState, useEffect } from "react";

export function detectAdBlocker() {
    return new Promise((resolve) => {
        const head = document.getElementsByTagName('head')[0];

        const cleanup = () => {
            const oldScript = document.getElementById('adblock-detection');
            if (oldScript) {
                head.removeChild(oldScript);
            }
        };

        cleanup();

        const script = document.createElement('script');
        script.id = 'adblock-detection';
        script.type = 'text/javascript';
        script.src = 'https://yandex.ru/ads/system/context.js';
        script.onload = () => {
            cleanup();
            resolve(true);
        };
        script.onerror = () => {
            cleanup();
            resolve(false);
        };
        head.appendChild(script);
    });
}



export function useAdBlockStatus(adfoxBlocks, isDesktop, isFull) {
    const [showAdfox, setShowAdfox] = useState(null);

    useEffect(() => {
        if (adfoxBlocks !== null) {
            detectAdBlocker().then((isNotBlocked) => {
                setShowAdfox(isNotBlocked);
            });
        } else {
            setShowAdfox(false);
        }
    }, [adfoxBlocks, isDesktop, isFull]);

    return showAdfox;
}
